import { axios } from '@Root/API'

export const remove = programmeTypeId => {
	return axios.delete(`program-type/${programmeTypeId}/delete`)
}
